import { gql } from 'apollo-boost';

export const GET_RECRUITS = gql`
    query getRecruits($offsetDate: String, $limit: Int!) {
        recruits(offsetDate: $offsetDate, limit: $limit) {
            count
            posts {
                uid
                type
                date
                title
                description
                year
                cover {
                    type
                    filename
                    url
                }
                recruit {
                    recipient
                }
            }
        }
    } 
`;
